



















































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import data from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import ContactInfo from "@/views/shared/ContactInfo.vue";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IContactVueModel } from "@/ts/models/IContactVueModel";
import { IRecyclingFacilityApplicationVueModel } from "@/ts/models/IRecyclingFacilityApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRecyclingFacilityApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        ContactInfo
    }
})
export default class RecyclingFacilityLiquidHazardousWaste extends Vue {
    name: string = "RecyclingFacilityLiquidHazardousWaste";
    title: string = "";
    index: number = NaN;
    
    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("LiquidHazardousWaste");

        this.$watch("form.isHandlingLiquidWaste", (n, o) => {
            if (this.isHandlingLiquidWaste) {
                if (this.$props.form.liquidWasteContractors.length === 0) {
                    this.$props.form.liquidWasteContractors.push(func.getEmptyContact());
                }
            } else {
                this.$props.form.liquidWasteContractors = [];
            }

        }, { immediate: true });
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$watch("form.liquidWasteContractors", (n, o) => {
            var isError = this.hasContratorErrors() || this.hasErrors;
            this.$props.vueStates.views[this.index].error = isError;
        }, { immediate: true, deep: true })

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isHandlingLiquidWaste(): boolean {
        return this.$props.form.isHandlingLiquidWaste == "true" || this.$props.form.isHandlingLiquidWaste == true;
    }

    get isRemovalDescriptionError(): boolean {
        return this.isHandlingLiquidWaste && func.isNullOrEmpty(this.$props.form.liquidWasteRemovalDescription);
    }

    get isHandlingDescriptionError(): boolean {
        return this.isHandlingLiquidWaste && func.isNullOrEmpty(this.$props.form.liquidWasteHandlingDescription);
    }

    get isTypesDescriptionError(): boolean {
        return this.isHandlingLiquidWaste && func.isNullOrEmpty(this.$props.form.liquidWasteTypesDescription);
    }

    hasContratorErrors(): boolean {
        /*
        let contractors = this.$props.form.liquidWasteContractors as [{ hasErrors: boolean }];
        return contractors.some(contractor => contractor.hasErrors);
        */
        for (var i = 0; i < this.$props.form.liquidWasteContractors.length; i++) {
            if (this.$props.form.liquidWasteContractors[i].hasErrors == true) {
                return true;
            }
        }
        return false;
    }

    addContractor(): void {
        this.$props.form.liquidWasteContractors.push(func.getEmptyContact());
    }

    removeContractor(contractorId: string): void {
        let contractors = this.$props.form.liquidWasteContractors as IContactVueModel[];
        let index = contractors.map((item) => item.id).indexOf(contractorId);
        contractors.splice(index, 1);
    }

    get hasErrors(): boolean {
        return this.isRemovalDescriptionError || this.isHandlingDescriptionError || this.isTypesDescriptionError;
    }
}
